"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _glamor = require("glamor");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _DismissIcon = _interopRequireDefault(require("./Toast/DismissIcon"));

var _NotificationIcon = _interopRequireDefault(require("./Toast/NotificationIcon"));

var _randomId = _interopRequireDefault(require("./Utils/randomId"));

var _ScreenReaderText = _interopRequireDefault(require("./ScreenReaderText"));

var _useDismissNotification = _interopRequireDefault(require("./hooks/useDismissNotification"));

var _useInternalRenderMarkdownInline = _interopRequireDefault(require("./hooks/internal/useInternalRenderMarkdownInline"));

var _useLocalizer = _interopRequireDefault(require("./hooks/useLocalizer"));

var _useStyleSet3 = _interopRequireDefault(require("./hooks/useStyleSet"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var ROOT_CSS = (0, _glamor.css)({
  display: 'flex',
  '& .webchat__toast__text': {
    flex: 1
  }
});

var BasicToast = function BasicToast(_ref) {
  var _ref$notification = _ref.notification,
      alt = _ref$notification.alt,
      id = _ref$notification.id,
      level = _ref$notification.level,
      message = _ref$notification.message;

  var _useStyleSet = (0, _useStyleSet3.default)(),
      _useStyleSet2 = _slicedToArray(_useStyleSet, 1),
      toastStyleSet = _useStyleSet2[0].toast;

  var contentId = (0, _react.useMemo)(function () {
    return "webchat__toast__".concat((0, _randomId.default)());
  }, []);
  var localize = (0, _useLocalizer.default)();
  var dismissNotification = (0, _useDismissNotification.default)();
  var renderMarkdownInline = (0, _useInternalRenderMarkdownInline.default)();
  var handleDismiss = (0, _react.useCallback)(function () {
    return dismissNotification(id);
  }, [dismissNotification, id]);
  var html = (0, _react.useMemo)(function () {
    return {
      __html: renderMarkdownInline(message)
    };
  }, [message, renderMarkdownInline]);
  return _react.default.createElement("div", {
    "aria-describedby": contentId,
    "aria-label": localize('TOAST_TITLE_ALT'),
    className: (0, _classnames.default)(ROOT_CSS + '', toastStyleSet + '', {
      'webchat__toast--error': level === 'error',
      'webchat__toast--info': level === 'info',
      'webchat__toast--success': level === 'success',
      'webchat__toast--warn': level === 'warn'
    }),
    role: "dialog"
  }, _react.default.createElement("div", {
    className: "webchat__toast__iconBox"
  }, _react.default.createElement(_NotificationIcon.default, {
    className: "webchat__toast__icon",
    level: level
  })), !!alt && _react.default.createElement(_ScreenReaderText.default, {
    text: alt
  }), _react.default.createElement("div", {
    "aria-hidden": !!alt,
    className: "webchat__toast__text",
    dangerouslySetInnerHTML: html,
    id: contentId
  }), _react.default.createElement("button", {
    "aria-label": localize('TOAST_DISMISS_BUTTON'),
    className: "webchat__toast__dismissButton",
    onClick: handleDismiss,
    type: "button"
  }, _react.default.createElement("div", {
    "aria-hidden": true,
    className: "webchat__toast__dismissButtonFocus"
  }, _react.default.createElement(_DismissIcon.default, null))));
};

BasicToast.propTypes = {
  notification: _propTypes.default.shape({
    alt: _propTypes.default.string,
    id: _propTypes.default.string.isRequired,
    level: _propTypes.default.string.isRequired,
    message: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = BasicToast;
exports.default = _default;